/* API query response wrapper & utility functions */

import * as _ from 'lodash';

export class ApiQueryResponse {
    public static readonly ResponseFieldNames = {
        FilterData: 'filterData',
        Results: 'results',
    };

    public constructor(responseData: any = {}) {
        this.responseData = _.cloneDeep(responseData);
    }

    private responseData: any = {};

    /* Access response fields by key */
    public getFieldAsObject(fieldName: string) {
        // Pluck and return a specific field from api response
        let result = {};

        if (!this.responseData || !fieldName) { return result; }

        return _.get(this.responseData, fieldName, {});
    }

    public getFieldAsArray(fieldName: string, applyTransform: boolean = true): Array<any> {
        // Pluck and return a specific array field from api response
        let result = [];

        if (!this.responseData || !fieldName) { return result; }

        result = _.get(this.responseData, fieldName, []);

        if (applyTransform) {
            result = _.values(result); // 20180610: Replaced Transforms.objectToArray(result);
        }

        return result;
    }

    public getFilterAsArray(filterName: string, applyTransform: boolean = true): Array<any> {
        // Pluck and return a specific filterData from api response
        let result = [];

        if (!this.responseData || !filterName) { return result; }

        const fieldName = `${ApiQueryResponse.ResponseFieldNames.FilterData}.${filterName}`;

        return this.getFieldAsArray(fieldName, applyTransform);
    }

    public getResultsArray(applyTransform: boolean = true): Array<any> {
        // Returns results field as array
        return this.getFieldAsArray(ApiQueryResponse.ResponseFieldNames.Results, applyTransform);
    }

    public getResponseObject() {
        // Returns the root response data object (for api methods that return a single object)
        return Object.assign({}, this.responseData);
    }

    /* Access filterData */
    public getFilterDataObject() {
        // Returns filterData field as object
        return this.getFieldAsObject(ApiQueryResponse.ResponseFieldNames.FilterData);
    }

    public getFilterDataObjectKeys(): Array<string> {
        // Returns filterData field keys
        let result: Array<string> = [];

        let filterDataObject = this.getFilterDataObject();
        if (filterDataObject) {
            result = _.keys(filterDataObject).map((k) => k.toString());
        }

        return result;
    }

    /* Lookups helpers */
    public getLookups(applyTransform: boolean = true) {
        // Returns object with fields for each filterData key with array as value
        // Should be added to state as { lookups: result }
        let result = {};

        let filterKeys = this.getFilterDataObjectKeys();
        filterKeys.forEach(k => {
            let filterArray = this.getFilterAsArray(k, true);
            result = _.set(result, k, filterArray);
        });

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/queries/apiqueryresponse.tsx